import { useMemo } from "react";
import { useSnackbarQuery } from "../../hooks";
import { UserDevice } from "../models";
import { QUERIES } from "../queries";

export function useUserDevices(userId: string) {
  const q = QUERIES.USER_DEVICES;
  const { data, loading, error, refetch } = useSnackbarQuery(q, {
    variables: {
      userId,
    },
  });

  const userDevices: UserDevice[] | undefined = useMemo(() => {
    if (data) {
      return data.userDevices;
    }

    return [];
  }, [data]);

  return {
    userDevices,
    loading,
    error,
    refetch,
  };
}
